module.exports = __webpack_public_path__ + "img/bg-matching.bbbe4af8.gif";